import http from '@/biz/http.mjs'

export default {
    readList: args => http.get('/amAr/listAmArRiByMap', args),
}
